import { gql } from '@apollo/client';

const GET_NEW_SECTION = gql`
  query {
    newSection: getNewSection {
      items {
        _id
        label
        title
        subtitle
        description
        customImageUrl
        position
        isActive
        album {
          _id
          title
          imageUrl
          isSingle
          releaseDate
          primaryArtist {
            _id
            displayName
          }
        }
      }
      songs {
        _id
        position
        song {
          _id
          name
          image
          primaryArtist {
            _id
            displayName
          }
        }
      }
    }
  }
`;

export interface NewSectionAlbum {
  _id: string;
  title: string;
  imageUrl?: string;
  isSingle: boolean;
  releaseDate?: string;
  primaryArtist?: { _id: string; displayName: string };
}

export interface NewSectionItem {
  _id: string;
  label: string;
  title: string;
  subtitle?: string;
  description?: string;
  customImageUrl?: string;
  position: number;
  isActive: boolean;
  album?: NewSectionAlbum;
}

export interface NewSectionSong {
  _id: string;
  position: number;
  song?: {
    _id: string;
    name?: string;
    image?: string;
    primaryArtist?: { _id: string; displayName: string };
  };
}

export interface GetNewSectionResponse {
  newSection?: {
    items: NewSectionItem[];
    songs: NewSectionSong[];
  };
}

export default GET_NEW_SECTION;
